<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';
    import Player from 'svelte-react-player';
    import Limiter from './_wrappers/Limiter.svelte';
    import Transition from './_wrappers/Transition.svelte';
    import Box from './_wrappers/Box.svelte';
    import clsx from 'clsx';

    // Utils
    import { getBorderRadius } from '$lib/global/helper/border-radius';

    // Types
    import type { TransitionEffect } from '$lib/types/Theme';
    import type { Box as BoxProps } from '$lib/types/Components/SharedTypes';

    export let url = '';
    export let autoplay = false;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let muted = false;
    export let playing = false;
    export let box: BoxProps;
    export let borderRadiusClass = '';
    export let layout = DEFAULT_LAYOUT;

    const { isInFramedColumn, isInColumn } = layout;

    if (autoplay) {
        playing = true;
        muted = true;
    }

    const handleReady = ({ wrapper }: { wrapper: HTMLDivElement }) => {
        if (wrapper) {
            const iframeElements = wrapper.getElementsByTagName('iframe');

            if (iframeElements.length !== 1) {
                return;
            }

            const iFrameClass = clsx(getBorderRadius('video'), {
                'max-sm:rounded-none': !layout.isInFramedColumn,
            });

            iframeElements[0].classList.add(iFrameClass);
        }
    };

    const videoWrapperClass = clsx('overflow-hidden', borderRadiusClass, {
        'w-[calc(100%+32px)] -translate-x-4 sm:w-full sm:translate-x-0':
            !isInFramedColumn && isInColumn,
    });
</script>

<Box {...box}>
    <Limiter>
        <Transition delay={transitionDelay} effect={transitionEffect}>
            <div class={videoWrapperClass}>
                <Player {url} fluid {muted} {playing} callbacks={{ onReady: handleReady }} />
            </div>
        </Transition>
    </Limiter>
</Box>
